/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { importExportTranslationsEn, importExportTranslationsEs } from '@spartacus/cart/import-export/assets';
import { CART_IMPORT_EXPORT_FEATURE, ImportExportRootModule } from '@spartacus/cart/import-export/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [ImportExportRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [CART_IMPORT_EXPORT_FEATURE]: {
          module: () => import('@spartacus/cart/import-export').then((m) => m.ImportExportModule),
        },
      },
      i18n: {
        resources: { en: importExportTranslationsEn, es: importExportTranslationsEs },
      },
    }),
  ],
})
export class ImportExportFeatureModule {}
